import useUser from '@hooks/auth/useUser';
import { ReactNode, useEffect } from 'react';

interface Props {
    children?: ReactNode;
}

function UserProvider({ children }:Props) {
    const { getUserProfile } = useUser();
    useEffect(getUserProfile, [getUserProfile]);
    return children;
}

export default UserProvider;
